import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "./inventory.css";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import BackIcon from "../../../assets/communication/Back.svg";
import DropDownIcon from "../../../assets/rewards/dropdown.svg";
import { Popup } from "@progress/kendo-react-popup";

import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import * as XLSX from 'xlsx';
import { REWARDS_CAMPAIGNS_DETAIL, REWARDS_INVENTORY_LIST } from "../../../routes";
import { fetchRedemptionExportList, fetchRedemptionList, fetchRewardInventoryDetail } from "../../../store/campaign";
import momentTZ from 'moment-timezone';
import { fetchAllOperatorList } from "../../../store/rewardsOperator";
import { MultiViewCalendar } from "@progress/kendo-react-dateinputs";
import { TextBox, InputSuffix } from "@progress/kendo-react-inputs";
import { Icon } from "@progress/kendo-react-common";
import { ComboBox, DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { filterBy } from '@progress/kendo-data-query';
import RedemptionSortableTable from "./redemption_sortable_table";
import ExportIcon from "../../../assets/rewards/export.svg";
import moment from "moment/moment";

const INVENTORY_TAB = {
  INVENTORY_INFO: "Info",
  INVENTORY_REDEMPTION: "Redemption",
};

export const RewardInventoryDetail = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const id = query.get("id");

  const [inventoryTab, setInventoryTab] = useState(INVENTORY_TAB.INVENTORY_INFO);
  const [detailData, setDetailData] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);
  const [operators, setOperators] = useState([]);
  const [operatorCombo, setOperatorCombo] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const { redemption_list, redemption_export_list } = useSelector(
    (state) => state.campaigns
  );


  const today = new Date();
  // End of this month
  const endOfThisMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  // Start date = 6 months ago, first day of that month
  const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);


  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const inputRef = useRef(null);


  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.access_reward"
  );

  const getData = async () => {
    setDetailLoading(true);
    dispatch(fetchAllOperatorList()).then((operatorRes) => {
      setOperators(operatorRes.payload);
      setOperatorCombo(operatorRes.payload);

      dispatch(fetchRewardInventoryDetail(id)).then((detail) => {
        setDetailData(detail.payload);
        getRedemptionData();
      });

    });

  };

  const getRedemptionData = async () => {

    // if (dateRange.start && dateRange.end) {
    setDetailLoading(true);


    let params = {
      start_date: moment(dateRange.start).isValid() ? moment(dateRange.start).format("YYYY-MM-DD") : '',
      end_date: moment(dateRange.end).isValid() ? moment(dateRange.end).format("YYYY-MM-DD") : '',
      operator_name: selectedOperator?.name || ''
    };

    dispatch(fetchRedemptionList({ params: params, id: id })).then((operatorRes) => {
      setDetailLoading(false);
    });
    // }

  };

  const getRedemptionExportData = async () => {
    setDetailLoading(true);

    let params = {
      start_date: moment(dateRange.start).format("YYYY-MM-DD"),
      end_date: moment(dateRange.end).format("YYYY-MM-DD"),
      operator_name: selectedOperator?.name || ''
    }


    dispatch(fetchRedemptionExportList({ params: params, id: id })).then((res) => {
      setDetailLoading(false);

      const formattedData = convertDates(res.payload);

      const worksheet = XLSX.utils.aoa_to_sheet(formattedData);

      // Set column widths: array of objects with width in characters
      worksheet['!cols'] = [
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Redemption List");
      XLSX.writeFile(workbook, "Redemption_List.xlsx");
    });

  };

  // Function to detect ISO date string (simple check)
  const isIsoDateString = (value) =>
    typeof value === "string" && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);

  // Convert all dates using momentTZ and your format
  const convertDates = (dataArray) =>
    dataArray.map((row) =>
      Array.isArray(row)
        ? row.map((cell) =>
          isIsoDateString(cell)
            ? momentTZ.tz(cell, "Asia/Singapore").local().format("DD-MM-YYYY hh:mm A")
            : cell
        )
        : row  // return non-array row as is, e.g. "" or other values
    );




  const exportToXlsx = (data, fileName) => {
    console.log(data);
    const wb = XLSX.utils.book_new(); // Create a new workbook
    const sheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, sheet);
    XLSX.writeFile(wb, `${fileName}.xlsx`); // Save the file
  };


  useEffect(() => {
    getData();
  }, [id]);




  useEffect(() => {
    getRedemptionData();
  }, [dateRange, selectedOperator]);



  const onTabChange = (tab) => {
    setInventoryTab(tab);
  };



  const onChange = ({ value: range }) => {
    setDateRange(range);
    if (range.start && range.end) {
      setShowDateRangePicker(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  const filterChange = (event) => {
    setOperatorCombo(filterBy(operators.slice(), event.filter));
  };

  const handleChange = (event) => {
    // The selected value is in event.value
    setSelectedOperator(event.target.value);
    console.log("Selected value:", event.target.value);
  };



  const InventoryInfoView = (() => {

    return (
      <div className="">
        <div style={{ margin: "10px" }} className="margin-bottom">

          {detailData.name ? (<div className="inventory_detail_child_box_main_detail_items">
            <div className="inventory_detail_child_box_main_detail_items_title inventory_detail_center_item detail_padding_bottom">
              Campaign Name
            </div>
            <div className="inventory_detail_child_box_main_detail_items_splitter" />
            <div className="inventory_detail_center_item inventory_detail_child_box_main_detail_items_subdetail detail_padding_bottom">

              <a
                href={`${REWARDS_CAMPAIGNS_DETAIL}?id=${id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inventory-hyper-link"
              >
                {detailData.name}
              </a>

            </div>
          </div>
          ) : (
            <div></div>
          )}
          <RenderRow
            title={"Campaign Description"}
            value={detailData.description || ''}
            isImage={false}
          />

          <RenderRow
            title={"Created On"}
            value={detailData.created_on ? momentTZ.tz(`${detailData.created_on}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
            isImage={false}
          />



          <RenderRow
            title={"Generated Coupons"}
            value={`${detailData.generated_coupons || ''}`}
            isImage={false}
          />

          <RenderRow
            title={"In-stock Quantity"}
            value={`${detailData.in_stock_quantity || ''}`}
            isImage={false}
          />

          <RenderRow
            title={"Redeemed Quantity"}
            value={`${detailData.redeemed_count || ''}`}
            isImage={false}
          />

          <RenderRow
            title={"Image"}
            value={detailData.images?.length > 0 ? detailData.images[0].url : ''}
            isImage={true}
          />

        </div>

      </div>
    );
  });


  const RenderRow = ({ title, value, isImage }) => {
    return (
      <>
        {value ? (
          <>
            <div className="inventory_detail_child_box_main_detail_items">
              <div className="inventory_detail_child_box_main_detail_items_title inventory_detail_center_item detail_padding_bottom">
                {title}
              </div>
              <div className="inventory_detail_child_box_main_detail_items_splitter" />
              <div className="inventory_detail_center_item inventory_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                {isImage ? (
                  <>
                    <img
                      style={{ height: "200px" }}
                      src={value}
                    />
                  </>
                ) : (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };



  return (
    <>
      {viewPermssion ? (
        <div className="inventory_container">

          {
            detailLoading && (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100% - 75px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            )
          }
          <div className="inventory_child_box">

            <div className="inventory_body">
              <div className="inventory_addheader" >
                <div className="back-title-group" onClick={(e) => {
                  navigate(REWARDS_INVENTORY_LIST);

                }}>
                  <img src={BackIcon} className="back-icon" />
                  <span className="back-text">Back</span>
                </div>

                {inventoryTab == INVENTORY_TAB.INVENTORY_REDEMPTION &&
                  (<div
                    className="inventory-export-btn"
                    onClick={() => {
                      getRedemptionExportData();
                    }}>
                    <img src={ExportIcon} />
                    Export
                  </div>)}
              </div>
            </div >

            <div className="inventory_scroll_box_detail">

              <div className="flex-between">
                <div className="inventory_tab_content">
                  <div className="tabs">
                    <div
                      onClick={() => onTabChange(INVENTORY_TAB.INVENTORY_INFO)}
                      className={`tab ${inventoryTab === INVENTORY_TAB.INVENTORY_INFO ? "isactive" : ""
                        }`}
                    >
                      {INVENTORY_TAB.INVENTORY_INFO}
                    </div>
                    <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                    <div
                      onClick={() => onTabChange(INVENTORY_TAB.INVENTORY_REDEMPTION)}
                      className={`tab ${inventoryTab === INVENTORY_TAB.INVENTORY_REDEMPTION ? "isactive" : ""
                        }`}
                    >
                      {INVENTORY_TAB.INVENTORY_REDEMPTION}
                    </div>

                  </div>

                </div>

              </div>



              <div className="inventory_items_list">
                {inventoryTab == INVENTORY_TAB.INVENTORY_INFO ? (
                  <InventoryInfoView />
                ) : (
                  <div>
                    <div className="inventory-flex-row">
                      <div style={{ width: '40%' }} className="inventory_create_item_main_box">
                        <div className="inventory_create_item_main_box_title">
                          Operator Name
                        </div>

                        <div className="inventory">

                          <ComboBox
                            id="operators"
                            data={operatorCombo}
                            textField="name"
                            dataItemKey="name"
                            filterable={true}
                            onFilterChange={filterChange}
                            style={{
                              width: '100%'
                            }}
                            onChange={handleChange}
                            value={selectedOperator}
                            placeholder="Choose Operator Name"
                          />

                        </div>

                      </div>
                      <div style={{ width: '40%' }} className="inventory_create_item_main_box">
                        <div className="inventory_create_item_main_box_title">
                          Redeemed/Acknowledged On
                        </div>
                        <div style={{ position: "relative", display: "inline-block", width: "100%" }}>

                          <TextBox
                            ref={inputRef}
                            readOnly
                            value={
                              dateRange.start && dateRange.end
                                ? `${formatDate(dateRange.start)} - ${formatDate(dateRange.end)}`
                                : ""
                            }
                            placeholder="Select date range"
                            onClick={() => setShowDateRangePicker(!showDateRangePicker)}
                            style={{ width: '100%' }}
                            suffix={() => (
                              <React.Fragment>
                                <InputSuffix>
                                  <Icon
                                    name="calendar"
                                    style={{ color: "#73007D" }}
                                    onClick={() => setShowDateRangePicker(!showDateRangePicker)}
                                  ></Icon>
                                </InputSuffix>
                              </React.Fragment>
                            )}
                          />

                          {showDateRangePicker && (
                            <div
                              style={{
                                marginTop: '1px',
                                position: "absolute",
                                zIndex: 1000,
                                background: "white",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                              }}
                            >
                              <MultiViewCalendar
                                mode="range"
                                value={dateRange}
                                onChange={onChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="inventory-clear-filter" style={{ marginTop: "50px" }}
                        onClick={() => {
                          setDateRange({ start: sixMonthsAgo, end: endOfThisMonth });
                          setSelectedOperator(null);
                        }}>
                        Clear Filter
                      </div>

                    </div>
                    <div style={{ maxHeight: '70%', overflow: 'auto' }}>

                      <RedemptionSortableTable data={redemption_list} />

                    </div>
                  </div>
                )


                }

              </div>
            </div>



          </div>

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}

    </>
  );
};
